module.exports = __webpack_public_path__ + "img/skip.44781a7b.svg";